import DataSummaryFactory from './DataSummaryFactory';

export default DataSummaryFactory;
